import type { ChatConversationDto } from "../../contracts";

export type CommercialHistoryPeriod = "today"
    | "yesterday"
    | "last-7-days"
    | "last-30-days"
    | "older";

export const commercialHistoryPeriodLabels: Record<CommercialHistoryPeriod, string> = {
    today: "Today",
    yesterday: "Yesterday",
    "last-7-days": "Last 7 Days",
    "last-30-days": "Last 30 Days",
    older: "Older"
};

export const commercialHistoryPeriodOrder: CommercialHistoryPeriod[] = [
    "today",
    "yesterday",
    "last-7-days",
    "last-30-days",
    "older"
];

export const getConversationActivityDate = (conversation: ChatConversationDto): Date => {
    const timestamp = conversation.last_message_at ?? conversation.created_at;
    return timestamp instanceof Date ? timestamp : new Date(timestamp);
};

export const getCommercialHistoryPeriod = (date: Date): CommercialHistoryPeriod => {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);
    const startOfLast7Days = new Date(startOfToday);
    startOfLast7Days.setDate(startOfLast7Days.getDate() - 7);
    const startOfLast30Days = new Date(startOfToday);
    startOfLast30Days.setDate(startOfLast30Days.getDate() - 30);

    if (date >= startOfToday) {
        return "today";
    }

    if (date >= startOfYesterday) {
        return "yesterday";
    }

    if (date >= startOfLast7Days) {
        return "last-7-days";
    }

    if (date >= startOfLast30Days) {
        return "last-30-days";
    }

    return "older";
};

export const groupConversationsByPeriod = (
    conversations: ChatConversationDto[]
): Partial<Record<CommercialHistoryPeriod, ChatConversationDto[]>> => {
    const grouped: Partial<Record<CommercialHistoryPeriod, ChatConversationDto[]>> = {};

    for (const conversation of conversations) {
        const period = getCommercialHistoryPeriod(getConversationActivityDate(conversation));
        grouped[period] = [...(grouped[period] ?? []), conversation];
    }

    return grouped;
};
